import React from 'react';
import { Box, Flex } from 'rebass/styled-components';

import { layout } from '../../../constants/constants';
import useFeatureToggle from '../../hooks/use-feature-toggle/useFeatureToggle';
import { FeatureToggle, Accordion, SingleColumnContent, TwoColumnContent, IconPack } from '../../models/app-data-model';
import SingleColumnBlock from '../single-column-block/single-column-block';
import TwoColumnBlock from '../two-column-block/two-column-block';
import AccordionItem from './accordion-item/accordion-item';
import './accordion.scss';


export type ContentAccordionProps = {
  contentAccordion: Accordion;
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
  corewellStyleOverrides?: boolean;
};

const ContentAccordion: React.FC<ContentAccordionProps> = ({ contentAccordion, featureToggles, iconPack, corewellStyleOverrides }: ContentAccordionProps) => {
  const showContentAccordion: boolean = useFeatureToggle('content-accordion', featureToggles);
  const accordionBlock = contentAccordion?.accordion_block?.find((el) => el.accordion_item);

  if (!showContentAccordion) {
    return null;
  }

  return (
    <Flex className="content-accordion">
      <Box className="accordion content-container" width={layout.pageWidth} px={layout.pagePaddingX} marginX={'auto'}>
        {accordionBlock?.accordion_item.map((item, index) => {
          return (
            <AccordionItem
              heading={item?.accordion_details?.header}
              linkId={item?.accordion_details?.link_id}
              headingClass={'content-accordion-item'}
              open={item?.accordion_details?.default_open}
              key={`accordion-item-${accordionBlock?.uid}-${index}`}
              iconPack={iconPack}
              defaultIcon={false}
              corewellStyleOverrides={corewellStyleOverrides}
            >
              {item?.accordion_details?.accordion_content.map((columnBlock, i) => {
                if (columnBlock.single_column_block) {
                  return (
                    <SingleColumnBlock
                      iconPack={iconPack}
                      key={'one-col-' + i}
                      column={columnBlock.single_column_block as SingleColumnContent}
                      featureToggles={featureToggles}
                    />
                  );
                } else if (columnBlock.two_column_content_block) {
                  return (
                    <TwoColumnBlock
                      key={'two-col-' + i}
                      content={columnBlock.two_column_content_block as TwoColumnContent}
                      featureToggles={featureToggles}
                      iconPack={iconPack}
                    />
                  );
                }
              })}
            </AccordionItem>
          );
        })}
      </Box>
    </Flex>
  );
};

export default ContentAccordion;
